import clsx from "clsx";
import type React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { QuestionCircle } from "react-bootstrap-icons";

interface Props {
  id: string;
  text: string;
  direction?: string;
  icon?: React.ReactNode;
  className?: string;
}

export default function Help(props: Props) {
  const icon = props.icon ?? <QuestionCircle />;
  const direction = props.direction ?? "top";

  return (
    <OverlayTrigger
      placement={direction === "top" ? "top" : "bottom-end"}
      overlay={
        <Tooltip id={props.id}>
          {/* biome-ignore lint/security/noDangerouslySetInnerHtml: html is from our server */}
          <div dangerouslySetInnerHTML={{ __html: props.text }} />
        </Tooltip>
      }
    >
      <span
        className={clsx(
          "text-muted d-flex align-items-center",
          props.className,
        )}
      >
        {icon}
      </span>
    </OverlayTrigger>
  );
}
